// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async getCompany({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/companies/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    async fetchCompanyList(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/companies`, config);
            ctx.commit('updateCompanyList', response.data) ;
        } catch (error) {
            return error;
        }
    },
    
    async saveCurrentCompanyFilter(ctx, company){
        localStorage.setItem('currentCompany', JSON.stringify(company))
        ctx.commit('updateCurrentCompany', company)
    },
    async getCurrentCompanyFilter(ctx){
        let company = localStorage.getItem('currentCompany')
        if(company){
            company = JSON.parse(company)
            ctx.commit('updateCurrentCompany', company)
        }
    },

    async getCompanies({ commit, state, rootState, rootGetters }, { id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = rootGetters.access_token;


            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/companies`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {

            if (error.status === 401) {

            }

            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async createCompany({ commit, state, rootState, rootGetters }, { name, address }) {

        const access_token = rootGetters.access_token;

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/companies`,
                {
                    name: name,
                    address: address,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );


            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async updateCompany({ commit, state, rootState, rootGetters }, { id, name, address }) {

        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/companies/${id}`,
                {
                    name: name,
                    address: address,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    }


};
